export default __webpack_public_path__ + "static/media/Group 707.819f8ce7.png";